import { StudentsState } from "./StudentsState"
import * as React from 'react'
import Milestone from './Milestone/Milestone'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import './StudentsList.css'

class StudentsList extends React.Component<any, StudentsState> {
    private studentIdList: string[] = []
    private studentClassIDList: string[] = []
    private asyncTask: firebase.Unsubscribe
    constructor(props: any) {
        super(props)
        this.state = new StudentsState()
    }

    public componentWillUpdate(nextProps: any, nextState: any) {
        if (nextProps.streamId !== undefined && nextProps.streamId.length > 0 && nextProps.streamId !== this.props.streamId) {
            this.asyncTask = firebase.firestore().collection('classes').doc(nextProps.streamId).collection('students').onSnapshot(o => {
                o.docChanges().forEach(elm => {
                    if (!this.studentIdList.includes(elm.doc.data()!.uuid)) {
                        const user = { user: '', uuid: '', isFirstClass: false }
                        user.user = elm.doc.data()!.username === undefined ? `${elm.doc.data()!.firstname} ${elm.doc.data()!.lastname.substring(0, 1)}.` : elm.doc.data()!.username
                        user.uuid = elm.doc.data()!.uuid
                        user.isFirstClass = elm.doc.data()!.isFirstClass
                        this.studentIdList.push(user.uuid)
                        this.studentClassIDList.push(elm.doc.id)
                        this.state.students!.push(user.user)
                        this.setState({ students: this.state.students, streamId: nextProps.streamId })
                    }
                })
            })
        } else if (nextProps.streamId.length < 0 && nextProps.streamId !== this.props.streamId) {
            this.setState({ students: [] })
        }
    }

    public componentWillUnmount() {
        if (this.asyncTask !== undefined && this.asyncTask !== null) {
            this.asyncTask()
        }
    }

    public render() {
        return (<div className="StudentsList">
            <fieldset>
                <legend>Class Info: {this.state.students.length}</legend>
                <ul>
                    {this.state.students.map((q, i) =>
                        <li className="nameList" key={i} data-id={i}>{q} <Milestone userId={this.studentIdList[i]} classId={this.state.streamId} participantId={this.studentClassIDList[i]} /></li>
                    )}
                </ul>
            </fieldset>
        </div>)
    }

}

export default StudentsList


// WEBPACK FOOTER //
// ./src/components/stream/students/StudentsList.tsx